import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import DatePresenter, {
  SHORT_FORMAT,
} from '../../../../../../../presenters/DatePresenter';
import Flash from '../../../../../../../components/forms/Flash';
import Row from '../../../../../../../components/Row';
import Column from '../../../../../../../components/Column';
import { Label } from '../../../../../../../components';

const AddInvoiceForm = ({
  values,
  handleSubmit,
  setFieldValue,
  errors,
  onModalClose,
}) => {
  const handleInvoiceDateChange = (id, date) => {
    setFieldValue(id, date);
  };
  return (
    <form onSubmit={handleSubmit}>
      <Flash response={errors} />
      <Row className="dates">
        <Column>
          <Label attr="startDate" text="Start date" />
          <div>
            <DatePicker
              wrapperClassName="invoice-date-field"
              id="startDate"
              selected={DatePresenter.dateObject(values.startDate)}
              onChange={(date) => handleInvoiceDateChange('startDate', date)}
              dateFormat="MM-dd-yyyy"
            />
          </div>
        </Column>
      </Row>
      <Row>
        <Column>
          <Label attr="endDate" text="End date" />
          <div>
            <DatePicker
              wrapperClassName="invoice-date-field"
              selected={DatePresenter.dateObject(values.endDate)}
              onChange={(date) => handleInvoiceDateChange('endDate', date)}
              dateFormat="MM-dd-yyyy"
            />
          </div>
        </Column>
      </Row>
      <div className="modal-actions">
        <button className="modal-save" type="submit">
          Generate Invoice
        </button>
        <button className="modal-close" onClick={onModalClose}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddInvoiceForm;

AddInvoiceForm.propTypes = {
  values: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

AddInvoiceForm.defaultProps = {
  errors: {},
};
